const VENDORS_FILTERED_PATHNAME = "/api/vendors-filtered";

/**
 * `/api/vendors-filtered` is a read that posts only to carry a JSON body. React
 * Router revalidates every active fetcher once an action resolves, so each
 * pharmacy filter change would otherwise cancel and re-fire every catalog
 * fetcher on the page.
 *
 * Compares the pathname rather than testing a substring: `formAction` may carry
 * a query string, and a substring test would also match a future sibling route
 * such as `/api/vendors-filtered-extra`, silently skipping catalog refreshes and
 * leaving stale products on screen.
 */
export function isVendorsFilteredAction(formAction: string | undefined) {
	if (!formAction) {
		return false;
	}

	// `formAction` is normally root-relative; the base only satisfies the parser.
	return (
		new URL(formAction, "http://localhost").pathname ===
		VENDORS_FILTERED_PATHNAME
	);
}
